import React from 'react'
import Modal from 'react-bootstrap/Modal';
function ModalMensajeInteractivo(props) {
    const { msg, collback, show } = props
    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            contentClassName='bg-warning text-light'>
            <Modal.Body bsPrefix='modal-body m-0 p-2'>
                <div className='container-fluid text-center'>
                    <div className='text-dark'><i className="fa-solid fa-circle-info fa-2xl"></i> {msg}</div>
                </div>
            </Modal.Body>
            <Modal.Footer bsPrefix='modal-footer m-0 p-0 px-2'>
                <button className='btn btn-sm btn-success' onClick={()=>collback(true)}><i className="fa-regular fa-thumbs-up fa-xl"></i> SI</button>
                <button className='btn btn-sm btn-danger' onClick={()=>collback(false)}><i className="fa-regular fa-thumbs-down fa-xl"></i> NO</button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalMensajeInteractivo
